(function () {
    "use strict";
    angular.module("cloudApp").factory("EmailList", EmailList);

    EmailList.$inject = ["$resource"];

    function EmailList($resource) {
        var resourceUrl = SERVER_API_URL + "api/email-lists/:id";

        var service = $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: { method: "PUT" },
            }
        );

        service.checkEmailDomain = function (email) {
            return $resource(SERVER_API_URL + "api/email-lists/check", {}, {
                get: {
                    method: 'GET',
                    params: {email: '@email'}
                }
            })
                .get({email: email})
                .$promise.then(function (response) {
                    if (typeof response.isBanned === "boolean") {
                        return response.isBanned;
                    } else {
                        return response;
                    }
                });
        };

        return service;
    }
})();
